import React, { useEffect, createElement } from 'react';
import { TrustBar } from './components/TrustBar';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
import { UrgencyBanner } from './components/UrgencyBanner';
import { ImageCarousel } from './components/ImageCarousel';
import { CTASection } from './components/CTASection';
import { StepsSection } from './components/StepsSection';
import { PersonalNote } from './components/PersonalNote';
import { ReviewCards } from './components/ReviewCards';
import { WhyChooseMe } from './components/WhyChooseMe';
import { AudioTestimonial } from './components/AudioTestimonial';
import { BenefitsSection } from './components/BenefitsSection';
import { MoreReviews } from './components/MoreReviews';
import { LeaveReview } from './components/LeaveReview';
import { PrivacySection } from './components/PrivacySection';
import { AboutMe } from './components/AboutMe';
import { TrainingSection } from './components/TrainingSection';
import { PersonalQuote } from './components/PersonalQuote';
import { AdditionalReviews } from './components/AdditionalReviews';
import { FinalStats } from './components/FinalStats';
import { FinalReviews } from './components/FinalReviews';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { captureUTMs, trackPurchase } from './utils/tracking';
export function App() {
  useEffect(() => {
    // Capturar UTMs de la URL si existen
    captureUTMs();
    // Simular página de "Gracias" si la URL tiene ?status=approved (Redirección de Hotmart)
    const params = new URLSearchParams(window.location.search);
    if (params.get('status') === 'approved' && !sessionStorage.getItem('purchase_tracked')) {
      trackPurchase();
      sessionStorage.setItem('purchase_tracked', 'true'); // Evitar disparar el evento 2 veces si recarga
    }
    // Meta Pixel Code
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '958699360076044');
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] font-inter text-white selection:bg-[#D4AF37] selection:text-black" data-id="element-0">
      <TrustBar data-id="element-1" />

      <main className="flex flex-col w-full overflow-hidden" data-id="element-2">
        <ImageCarousel data-id="element-3" />

        <div className="py-8" data-id="element-4">
          <CTASection data-id="element-5" />
        </div>

        <UrgencyBanner data-id="element-6" />
        <StepsSection data-id="element-7" />
        <PersonalNote data-id="element-8" />

        <div className="py-8" data-id="element-9">
          <CTASection data-id="element-10" />
        </div>

        <GuaranteeSection data-id="element-11" />
        <ReviewCards data-id="element-12" />

        <div className="py-8" data-id="element-13">
          <CTASection data-id="element-14" />
        </div>

        <WhyChooseMe data-id="element-15" />
        <AudioTestimonial data-id="element-16" />
        <BenefitsSection data-id="element-17" />
        <MoreReviews data-id="element-18" />
        <LeaveReview data-id="element-19" />
        <PrivacySection data-id="element-20" />
        <AboutMe data-id="element-21" />
        <TrainingSection data-id="element-22" />
        <PersonalQuote data-id="element-23" />

        <div className="py-8" data-id="element-24">
          <CTASection data-id="element-25" />
        </div>

        <AdditionalReviews data-id="element-26" />
        <FinalStats data-id="element-27" />
        <FinalReviews data-id="element-28" />
        <FAQSection data-id="element-29" />
      </main>

      <Footer data-id="element-30" />
    </div>;
}